import type { ButtonComponentDesign } from '@coorum-research/shared-common/types/component-design.type'
import { type CSSProperties, forwardRef } from 'react'
import { PresetIcon } from './icons/PresetIcon'

type Props = {
  configJson: ButtonComponentDesign
  onClick?: () => void
  style?: CSSProperties
}

/*
 * NOTE: launcher領域(埋め込み先のHTML上)で使うため、tailwindは使用しない
 */

const RoundTemplateButton = forwardRef<HTMLButtonElement, Props>(
  function RoundTemplateButton({ configJson, style, onClick }, ref) {
    return (
      <button
        style={{
          cursor: 'pointer',
          padding: 0,
          margin: 0,
          display: 'block',
          width: 59,
          height: 59,
          backgroundColor: configJson.theme?.mainColor,
          border: 'none',
          borderRadius: '100%',
          flexShrink: 0,
          overflow: 'hidden',
          ...style,
        }}
        onClick={onClick}
        ref={ref}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {configJson.title ? (
            <>
              <PresetIcon
                presetIcon={configJson?.presetIcon}
                width={24}
                height={24}
                fill={configJson.theme?.mainTextColor}
              />
              <p
                style={{
                  color: configJson.theme?.mainTextColor,
                  fontSize: '9px',
                  fontWeight: 700,
                  whiteSpace: 'pre-wrap',
                }}
              >
                {configJson.title}
              </p>
            </>
          ) : (
            <PresetIcon
              presetIcon={configJson?.presetIcon}
              width={32}
              height={32}
              fill={configJson.theme?.mainTextColor}
            />
          )}
        </div>
      </button>
    )
  }
)

const RoundImageButton = forwardRef<HTMLButtonElement, Props>(
  function RoundImageButton({ configJson, style, onClick }, ref) {
    return (
      <button
        style={{
          cursor: 'pointer',
          padding: 0,
          margin: 0,
          display: 'block',
          width: 59,
          height: 59,
          border: 'none',
          borderRadius: '100%',
          flexShrink: 0,
          ...style,
        }}
        onClick={onClick}
        ref={ref}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {configJson.imageUrl &&
            <img
              src={configJson.imageUrl}
              style={{
                width: '100%',
                height: 59,
                objectFit: 'cover',
                borderRadius: '100%',
              }}
              alt={configJson.title ?? 'popup round image'}
            />
          }
        </div>
      </button>
    )
  }
)

export const DesignedButton = forwardRef<HTMLButtonElement, Props>(
  function DesignedButton({ configJson, style, onClick }, ref) {
    return (
      <>
        {(configJson?.buttonType === 'round' && configJson?.designType === 'template') && (
          <RoundTemplateButton
            ref={ref}
            configJson={configJson}
            onClick={onClick}
            style={style}
          />
        )}
        {(configJson?.buttonType === 'round' && configJson?.designType === 'image') && (
          <RoundImageButton
            ref={ref}
            configJson={configJson}
            onClick={onClick}
            style={style}
          />
        )}
      </>
    )
  }
)
